module.exports = __webpack_public_path__ + "static/media/file.fe28040e.svg";